import { render, staticRenderFns } from "./BuilderNav.vue?vue&type=template&id=20c01e91"
import script from "./BuilderNav.vue?vue&type=script&lang=js"
export * from "./BuilderNav.vue?vue&type=script&lang=js"
import style0 from "./BuilderNav.vue?vue&type=style&index=0&id=20c01e91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports